<app-dialog
  [header]="'CONTACT_RM.TITLE' | translate"
  [modal]="true"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  (onHide)="onHide()"
  [style]="{ width: '540px' }"
  [styleClass]="'contact-rm-dialog'"
>
  <div class="flex flex-col gap-5 w-full">
    <p class="text-body-large text-muted-color !mb-0">{{ 'CONTACT_RM.SUBTITLE' | translate }}</p>

    <form [formGroup]="contactForm" class="flex flex-col gap-5 w-full">
      <!-- Request Type -->
      <div class="flex flex-col gap-1 w-full">
        <label class="text-label-medium-large-r text-headingText">
          {{ 'CONTACT_RM.REQUEST_LABEL' | translate }}<span class="text-error">*</span>
        </label>
        <p-select
          formControlName="request"
          [options]="requestTypes"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'CONTACT_RM.PLEASE_SELECT' | translate"
          styleClass="w-full"
        >
          <ng-template #selectedItem let-selectedOption>
            {{ selectedOption?.label }}
          </ng-template>
          <ng-template let-option #item>
            {{ option.label }}
          </ng-template>
        </p-select>
        @if (contactForm.get('request')?.invalid && contactForm.get('request')?.touched) {
          <small class="text-error">{{ 'CONTACT_RM.REQUEST_REQUIRED' | translate }}</small>
        }
      </div>

      <!-- Comments -->
      <div class="flex flex-col gap-1 w-full">
        <label class="text-label-medium-large-r text-headingText">
          {{ 'CONTACT_RM.COMMENTS_LABEL' | translate }}
        </label>
        <textarea
          pTextarea
          formControlName="comments"
          rows="4"
          [placeholder]="'CONTACT_RM.COMMENTS_PLACEHOLDER' | translate"
          [aria-label]="'CONTACT_RM.COMMENTS_LABEL' | translate"
          class="w-full border border-surface-200 rounded-lg p-2.5 text-body-large text-bodyText bg-backgroundWhite resize-none focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
        ></textarea>
        @if (contactForm.get('comments')?.invalid && contactForm.get('comments')?.touched) {
          <small class="text-error">{{ 'CONTACT_RM.REQUEST_REQUIRED' | translate }}</small>
        }
      </div>
    </form>

    <!-- Actions: 50/50 Cancel + Submit -->
    <div class="flex gap-3 w-full">
      <app-button
        type="button"
        variant="secondary"
        [label]="'CONTACT_RM.CANCEL' | translate"
        [fluid]="true"
        class="basis-1/2"
        (onClick)="onHide()"
        [disabled]="submitting()"
      />
      <app-button
        type="button"
        variant="primary"
        [label]="'CONTACT_RM.SUBMIT' | translate"
        [fluid]="true"
        class="basis-1/2"
        (onClick)="submitContact()"
        [loading]="submitting()"
      />
    </div>
  </div>
</app-dialog>
